import { mergeLeft } from 'ramda'
import { createSelectorCreator, defaultMemoize } from 'reselect'
import { moizeMaxSize } from 'app/constants'
import { RootState } from 'app/store'
import { emptyObj, objIfNilOrEmpty } from 'app/utils/fp'
import { memoizedObj } from 'utils/misc'

export const selectParamsFromProps =
  <P>(defaultParams = emptyObj as P) =>
  (_: RootState, params: P = emptyObj as P): P => {
    // @fixme fix these typings
    // @ts-ignore
    return objIfNilOrEmpty(memoizedObj(mergeLeft(params, defaultParams))) as P
  }

export const createSharedSelector = createSelectorCreator(defaultMemoize, { maxSize: moizeMaxSize })
